export enum ResourceType {
    DeviceService = 2
}